import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Property } from '../../models/property.model';
 
const PropertyRules: React.FC<{ property: Property | null }> = ({ property }) => {
  if (!property) {
    return <div className="text-center mt-5">Loading...</div>;
  }
  return (
    <div className="">
      {/* <div className="card border-0 shadow-sm"> */}
        <div className="card-body">
          <div className="rules-content">
            {property.termsAndConditions ? (
              <ul className="list-unstyled mb-0">
                {property.termsAndConditions
                  .split('\n')
                  .filter(line => line.trim() !== '')
                  .map((line, idx) => (
                    <li key={idx} className="d-flex align-items-start mb-1">
                      <i className="bi bi-check-circle-fill text-success me-2 flex-shrink-0"></i>
                      <span className="text-dark">{line.trim()}</span>
                    </li>
                  ))}
              </ul>
            ) : (
              <div className="text-center py-2">
                <i className="bi bi-info-circle text-muted mb-2" style={{ fontSize: '1.5rem' }}></i>
                <p className="text-muted mb-0">
                  No specific rules or terms have been set for this property.
                </p>
              </div>
            )}
          </div>
        </div>
      {/* </div> */}
    </div>
  );
};
 
export default PropertyRules;
 